'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var react = require('react');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var alloyDropdown_module = require('./alloy-dropdown.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var DEFAULT_FILTER = function () { return true; };
var DEFAULT_GETPROPS = function () { return ({}); };
var GROUPITEMTYPE = 'optGroupHead';
var DropdownMenu = function (_a) {
    var _b;
    var dataCsMask = _a.dataCsMask, _c = _a.filterBeforeDisplay, filterBeforeDisplay = _c === void 0 ? DEFAULT_FILTER : _c, _d = _a.getItemProps, getItemProps = _d === void 0 ? DEFAULT_GETPROPS : _d, _e = _a.getMenuProps, getMenuProps = _e === void 0 ? DEFAULT_GETPROPS : _e, _f = _a.isOpen, isOpen = _f === void 0 ? false : _f, icon = _a.icon, items = _a.items, itemToString = _a.itemToString, keyToString = _a.keyToString, titleToString = _a.titleToString, menuSize = _a.menuSize, placeholder = _a.placeholder, selectedItem = _a.selectedItem, highlightedIndex = _a.highlightedIndex;
    var isGroupTitle = function (item) { return (item === null || item === void 0 ? void 0 : item.itemType) === GROUPITEMTYPE; };
    var getItem = function (item, index, containsGroupTitle) {
        var itemAsString = itemToString(item);
        var keyAsString = keyToString(item);
        var titleAsString = titleToString(item);
        return isGroupTitle(item) ? (jsxRuntime.jsx("div", tslib.__assign({ className: "".concat(alloyDropdown_module.default['dropdown__opt-group-label'], " ps-2") }, { children: jsxRuntime.jsx("li", tslib.__assign({ role: "separator" }, { children: itemToString(item) })) }), keyAsString)) : (react.createElement("li", tslib.__assign({}, getItemProps({
            'data-cs-mask': dataCsMask,
            key: keyAsString,
            index: index,
            item: item
        }), { "aria-selected": itemToString(selectedItem) === itemAsString, className: "\n                ".concat(alloyDropdown_module.default['dropdown__menuItem'], "\n                ").concat(highlightedIndex === index
                ? alloyDropdown_module.default['dropdown__menuItem--highlighted']
                : '', " \n                ").concat(placeholder && itemToString(placeholder) === itemAsString
                ? alloyDropdown_module.default['placeHolderColor']
                : '', "\n                ").concat(alloyDropdown_module.default['cursor-pointer'], " \n                ").concat(containsGroupTitle ? 'ps-3' : ' ps-2', "               \n                pe-2"), key: keyAsString, title: titleAsString }),
            itemAsString,
            icon && itemToString(placeholder) !== itemAsString ? icon : null));
    };
    var containsGroupTitle = Array.isArray(items)
        ? items.find(isGroupTitle)
        : Array.from(items);
    var newArrItems = Array.isArray(items) ? items : Array.from(items);
    return (jsxRuntime.jsx("div", tslib.__assign({ className: cx__default.default('dropdown-menu mt-0 pb-4 pt-0 w-100', alloyDropdown_module.default['dropdown-menu-wrapper'], { show: isOpen }) }, { children: jsxRuntime.jsx("ul", tslib.__assign({ className: cx__default.default(alloyDropdown_module.default['dropdown__menu'], ' w-100 rounded-0 py-0 my-0 text-start ps-0', (_b = {}, _b["".concat(alloyDropdown_module.default['dropdown__menu--small'])] = menuSize === 'small', _b)) }, getMenuProps(), { children: newArrItems
                .filter(filterBeforeDisplay)
                .map(function (item, index) { return getItem(item, index, containsGroupTitle); }) })) })));
};
var DropdownMenu$1 = DropdownMenu;

exports.default = DropdownMenu$1;
//# sourceMappingURL=DropdownMenu.js.map
